/* LL: touch pauses complement CSS hover/focus pausing. */
(() => {
  if (window.LLTicker) return;
  window.LLTicker = true;
  const ready = new WeakSet();
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  // Repeat complete sets equally in both halves, including on wide screens.
  // Copies are decorative and never add keyboard stops or editor block handles.
  const fill = ticker => {
    const lists = [...ticker.querySelectorAll('.ll-ticker__list')];
    if (lists.length !== 2) return;
    lists.forEach(list => list.querySelectorAll('[data-ll-ticker-copy]').forEach(item => item.remove()));
    const originals = [...lists[0].children];
    const setWidth = originals.reduce((width, item) => width + item.getBoundingClientRect().width, 0);
    if (!setWidth) return;
    const repeats = Math.ceil(ticker.clientWidth / setWidth);
    lists.forEach(list => {
      for (let repeat = 1; repeat < repeats; repeat++) {
        originals.forEach(item => {
          const clone = item.cloneNode(true);
          clone.setAttribute('data-ll-ticker-copy', '');
          clone.setAttribute('aria-hidden', 'true');
          clone.removeAttribute('data-shopify-editor-block');
          clone.querySelectorAll('a').forEach(link => { link.tabIndex = -1; });
          list.append(clone);
        });
      }
    });
    ticker.classList.add('is-filled');
  };
  const observer = new ResizeObserver(entries => entries.forEach(entry => fill(entry.target)));
  const init = () => document.querySelectorAll('.ll-ticker').forEach(ticker => {
    if (ready.has(ticker)) return;
    ready.add(ticker);
    const button = ticker.querySelector('.ll-ticker__pause');
    const toggle = () => {
      const paused = ticker.classList.toggle('is-paused');
      button?.setAttribute('aria-pressed', String(paused));
      if (button) button.firstElementChild.textContent = paused ? '\u25B6' : '\u2161';
    };
    button?.addEventListener('click', toggle);
    let touch;
    ticker.addEventListener('pointerdown', event => {
      if (event.pointerType === 'touch') touch = { x: event.clientX, y: event.clientY };
    }, { passive: true });
    ticker.addEventListener('pointerup', event => {
      if (touch && event.pointerType === 'touch' && !event.target.closest('a, button') && Math.hypot(event.clientX - touch.x, event.clientY - touch.y) < 10) toggle();
      touch = null;
    }, { passive: true });
    ticker.addEventListener('pointercancel', () => { touch = null; });
    fill(ticker);
    observer.observe(ticker);
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', event => {
    event.target.querySelectorAll('.ll-ticker').forEach(ticker => observer.unobserve(ticker));
  });
  document.fonts.ready.then(() => document.querySelectorAll('.ll-ticker').forEach(fill));
  reducedMotion.addEventListener('change', () => document.querySelectorAll('.ll-ticker').forEach(fill));
  init();
})();
